export enum DicaronCommonErrorCode {
  /** 잘못된 요청 */
  BAD_REQUEST = 'BAD_REQUEST',
  /** 계정 비로그인 상태 */
  LOGIN_REQUIRED = 'LOGIN_REQUIRED',
  /** "NORMAL"이 아닌 계정 상태 */
  INVALID_ACCOUNT_STATUS = 'INVALID_ACCOUNT_STATUS'
}

export enum DicaronIssueAndHomeErrorCode {
  /** 해외번호 유저 */
  FOREIGNER = 'FOREIGNER',
  /** 디카롱 서비스 점검 */
  MAINTENANCE = 'MAINTENANCE',
  /** 파파스 전자증명서 점검 중 */
  PAPAS_MAINTENANCE = 'PAPAS_MAINTENANCE',
  /** 정부24 발급 불가 */
  PAPAS_NOT_APPLICABLE = 'PAPAS_NOT_APPLICABLE',
  /** 발급지연 */
  TOO_MANY_REQUESTS = 'TOO_MANY_REQUESTS',
  /** 전자증명서 요청 횟수 초과 */
  PAPAS_TOO_MANY_REQUEST = 'PAPAS_TOO_MANY_REQUEST',
  /** 14세 미만 */
  UNDER_14 = 'UNDER_14',
  /** 알 수 없는 오류(front에서 정의한 코드) */
  UNKNOWN = 'UNKNOWN'
}
